import React from "react";
import LookupBase from "./LookupBase";

export default function LookupAgendaMaster(props) {
  const endpoint = "/api/agenda-masters"; // cek nama endpoint Strapi anda, ganti jika perlu
  function queryBuilder(s) {
    return `?filters%5Bsubject%5D%5B$containsi%5D=${encodeURIComponent(s)}&populate=*`;
  }
  function renderItem(item) {
    return (
      <>
        <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">🗂️</div>
        <div>
          <div className="font-medium">{item.subject ?? item.name}</div>
          <div className="text-xs text-gray-500">{item.Area ?? item.area ?? ""}</div>
        </div>
      </>
    );
  }
  return <LookupBase endpoint={endpoint} queryBuilder={queryBuilder} renderItem={renderItem} {...props} />;
}
